<template>
  <div>
    <div v-if="this.template.length !== 0">
      <el-divider></el-divider>
      <h3 style="margin-bottom: 20px">行程信息</h3>
      <!-- 测试按钮 -->
      <!-- <el-button @click="showitems">点击</el-button> -->
    </div>

    <div>
      <!-- 模版 -->
      <div v-for="(item, index) of this.information_items"
           :key="index">
        <div style="display: flex; margin-bottom: 20px">
          <span class="resv-visable">{{ item.name }}：</span>
          <!-- date:日期类型 -->
          <el-date-picker v-if="'date' == item.type"
                          :type="item.type"
                          style="width: 200px"
                          size="mini"
                          v-model="item.value"
                          placeholder="请输入内容"></el-date-picker>
          <!-- textarea:长文本 -->
          <el-input v-if="'textarea' == item.type"
                    type="textarea"
                    rows="3"
                    resize="none"
                    style="width: 40%"
                    size="mini"
                    maxlength="300"
                    v-model="item.value"
                    :placeholder="'请输入' + item.name"
                    :clearable="true"></el-input>

          <!-- text:输入框 -->
          <el-input v-if="'text' == item.type"
                    :type="item.type"
                    style="width: 200px"
                    size="mini"
                    v-model="item.value"
                    :placeholder="'请输入' + item.name"
                    :clearable="true"></el-input>
          <!-- time:时间类型 -->
          <el-input v-if="'time' == item.type"
                    style="width: 200px"
                    size="mini"
                    v-model="item.value"
                    :placeholder="'请输入' + item.name"
                    :clearable="true"></el-input>
          <!-- num:数值 -->
          <el-input-number v-if="'num' == item.type"
                           :type="item.type"
                           style="width: 150px"
                           size="mini"
                           :min="0"
                           v-model.number="item.value"></el-input-number>
          <!-- boolean：布尔 -->
          <el-radio-group style="padding-top: 8px"
                          v-if="'boolean' == item.type"
                          v-model="item.value">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'other-resveration-info',
  data() {
    return {
      name: false,
      information_items: this.template,
    }
  },
  props: {
    template: Array,
  },
  watch: {
    template: {
      handler(newValue, oldValue) {
        this.information_items = newValue
      },
      immediate: true,
    },
  },
  methods: {
    showitems() {
      // console.log(this.information_items);
      // console.log(this.information_items.length);
      // console.log(this.information_items);
    },
  },
}
</script>

<style>
</style>